const {
  REACT_APP_host_url,
  REACT_APP_api_url = "https://stage-api.ftpro.vip/api/v1",
  REACT_APP_google_api_key = "AIzaSyCwNncQIkXn7P4GH8Hzhi1l4LoQ5Ihm56Q",
} = process.env;

module.exports = {
  // urls
  url: REACT_APP_host_url,
  API_URL: REACT_APP_api_url,

  // google map key
  GOOGLE_API_KEY: REACT_APP_google_api_key,
};
